<script>
	import promise_in_flight_store from 'shared/promise_in_flight_store'
	import { fade } from 'svelte/transition'
	import fetchy from 'shared/fetchy'
	import { storefront_api2_prefix, google_analytics_tag_id } from 'shared/var'
	const api2_fetch = fetchy(storefront_api2_prefix)

	export let list
	export let title_text
	export let description_text
	export let signup_location
	export let submit_text = `Sign up`
	export let success_redirect

	let request = null
	let email = ``
	let email_element

	const submit = () => {
		request = api2_fetch(`newsletter/subscribe`, {
			method: `POST`,
			body: {
				email,
				list,
				signup_location,
			},
		}).then(() => {
			if (success_redirect?.length) {
				window.location = success_redirect
			}
		})

		gtag(`event`, `newsletter_signup`, {
			list,
			autofilled: email_element.matches(`:autofill`),
			send_to: google_analytics_tag_id,
		})
	}

	$: request_in_flight = request && promise_in_flight_store(request)
</script>

<form on:submit|preventDefault={submit}>
	<fieldset disabled={$request_in_flight}>
		{#if title_text?.length}<div class="title">{title_text}</div>{/if}
		<div class="desc">
			{description_text}
		</div>
		<div>
			<div class="oneline">
				<input
					type="email"
					name="email"
					class="email"
					placeholder="lex@trex-arms.com"
					autocomplete="email"
					bind:value={email}
					bind:this={email_element}
				/>
				<input type="submit" value={submit_text}>
			</div>
			{#if request}
				{#await request then _see_gh_issue_3704}
					<div class="status success" transition:fade|global>
						Thanks for subscribing. We'll be in touch.
					</div>
				{:catch error}
					<div class="status error" transition:fade|global>
						{
							error?.errors
								? error.errors.map(({ message }) => message).join(`, `)
								: error.toString()
						}
					</div>
				{/await}
			{/if}
		</div>
	</fieldset>
</form>

<style>
	form {
		font-size: 13px;
		max-width: 600px;
	}

	fieldset {
		border: 0;
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	.oneline {
		display: flex;
		align-items: center;
	}

	fieldset[disabled] input {
		opacity: .5;
	}

	.title {
		color: #FFF;
		text-transform: uppercase;
		font-size: 12px;
		line-height: 1.2;
		font-weight: 500;
	}
	.desc {
		color: #cecece;
	}
	.email {
		width: 100%;
	}
	.status {
		line-height: 20px;
		padding: 10px 0;
		height: auto;
	}
	.success {
		color: #ceff51;
	}
	.error {
		color: #ff6231;
	}
	input[type=email] {
		border: 1px solid #cecece;
		background: black;
	}
	input[type=submit] {
		text-transform: uppercase;
		font-weight: 500;
		background: #ceff51;
		border-radius: 3px;
		color: black;
		line-height: 38px;
		padding: 0 10px;
		margin: 0 0 0 10px;
		border: 0;
	}
</style>
